
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.34 15a2.5 2.5 0 003.413.918l.003-.001.37-.214a7.482 7.482 0 002.374 1.37v.427a2.5 2.5 0 005 0v-.427a7.478 7.478 0 002.373-1.372l.373.215a2.501 2.501 0 102.5-4.334l-.37-.213a7.582 7.582 0 000-2.742l.37-.213a2.501 2.501 0 00-2.5-4.333l-.371.214A7.482 7.482 0 0012.5 2.928V2.5a2.5 2.5 0 00-5 0v.428a7.48 7.48 0 00-2.373 1.371l-.373-.216a2.501 2.501 0 10-2.5 4.334l.37.213a7.584 7.584 0 000 2.742l-.37.213A2.505 2.505 0 001.34 15zM10 6.667a3.333 3.333 0 110 6.666 3.333 3.333 0 010-6.666z","fill":"#3C464F"}})])
          )
        }
      }
    